import {useEffect,useRef,useState} from 'react';
import type {PresentationSlide} from '../../shared/protocol.ts';
import {cachedScenarioVideo,warmScenarioVideos} from '../scenarioMedia.ts';
/** Supplied animated slides contain their own artwork and Arabic titles. */
export function ScenarioScreen({slide}:{slide:PresentationSlide}) {
  const url=slide.video||'',player=useRef<HTMLVideoElement>(null);
  const [cached,setCached]=useState<string|null>(null),[paused,setPaused]=useState(false),[failed,setFailed]=useState(false);
  useEffect(()=>{
    let live=true,blob:string|null=null;
    void cachedScenarioVideo(url).then(value=>{blob=value;if(live)setCached(value);else if(value)URL.revokeObjectURL(value);});
    return ()=>{live=false;if(blob)URL.revokeObjectURL(blob);};
  },[url]);
  const play=()=>{const video=player.current;if(!video)return;video.muted=true;void video.play().then(()=>setPaused(false)).catch(()=>setPaused(true));};
  useEffect(()=>{play();},[url,cached]);
  useEffect(()=>{
    const resume=()=>{if(!document.hidden)play();};document.addEventListener('visibilitychange',resume);
    return()=>document.removeEventListener('visibilitychange',resume);
  },[]);
  return <section aria-label={slide.arabicTitle} dir="rtl" className="relative h-full w-full overflow-hidden bg-[#042b4f]">
    <video ref={player} src={cached||url} autoPlay loop muted playsInline preload="auto"
      aria-label={slide.arabicTitle} className="h-full w-full object-contain"
      onCanPlay={()=>{setFailed(false);play();warmScenarioVideos(url);}}
      onPlaying={()=>setPaused(false)} onError={()=>{setFailed(true);warmScenarioVideos(url);}} />
    {(paused||failed)&&<div className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-[#042b4f]/85 p-8 text-center text-white">
      <h1 className="text-3xl font-bold">{slide.arabicTitle}</h1>
      <button className="rounded-2xl bg-white px-8 py-4 text-lg font-bold text-[#042b4f]" onClick={()=>{if(failed)player.current?.load();play();}}>
        {failed?'إعادة تحميل الشريحة':'تشغيل الشريحة'}
      </button>
    </div>}
  </section>;
}
